import { render } from "./ClientServiceInfo.vue?vue&type=template&id=09c32d04&scoped=true"
import script from "./ClientServiceInfo.vue?vue&type=script&lang=js"
export * from "./ClientServiceInfo.vue?vue&type=script&lang=js"

import "./ClientServiceInfo.vue?vue&type=style&index=0&id=09c32d04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c32d04"]])

export default __exports__